module.exports = __webpack_public_path__ + "static/ecg_icon-8b982b8b29fe195d285076080d1a7626.png";